module.exports = require("/opt/build/repo/src/gatsby/gatsby-browser.ts");